import { Col, Form, Input, Row } from "antd";
import type React from "react";
import type { TemplateEditor } from "@/components/ui/RichTextEditor";
import { RichTextEditor } from "../index";

const { TextArea } = Input;

interface PatientInfoSectionProps {
  physicalExamEditor: TemplateEditor;
  onEditorContentChange: (id: string | number, content: string) => void;
}

const PatientInfoSection: React.FC<PatientInfoSectionProps> = ({
  physicalExamEditor,
  onEditorContentChange,
}) => {
  return (
    <>
      <Row gutter={16} className="form-row">
        <Col span={12}>
          <Form.Item label="HRN" name="hrn" className="form-item">
            <Input className="form-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Name" name="patientName" className="form-item">
            <Input className="form-input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16} className="form-row">
        <Col span={12}>
          <Form.Item label="NRIC" name="nric" className="form-item">
            <Input className="form-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Drug Allergy" name="drugAllergy" className="form-item">
            <Input className="form-input" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Present Illness" name="presentIllness" className="form-item">
        <TextArea autoSize={{ minRows: 2, maxRows: 4 }} className="form-textarea" />
      </Form.Item>

      <Form.Item
        label="Past History / Current Medications"
        name="pastHistory"
        className="form-item"
      >
        <TextArea autoSize={{ minRows: 2, maxRows: 4 }} className="form-textarea" />
      </Form.Item>

      <Form.Item label="Physical Examination" className="form-item">
        <div className="chart-rich-editor-wrapper">
          <RichTextEditor
            editor={physicalExamEditor}
            isLocked={false}
            onCopy={() => {}}
            onRemove={() => {}}
            onContentChange={onEditorContentChange}
          />
        </div>
        <Form.Item name="physicalExamination" hidden>
          <Input />
        </Form.Item>
      </Form.Item>
    </>
  );
};

export default PatientInfoSection;
